import { render, staticRenderFns } from "./profileMobile.vue?vue&type=template&id=64efad2a"
import script from "./profileMobile.vue?vue&type=script&lang=js"
export * from "./profileMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports